import type { ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';

interface TooltipProps {
  label: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
  sideOffset?: number;
}

export const Tooltip = ({
  label,
  children,
  side = 'top',
  align = 'center',
  delayDuration = 200,
  sideOffset = 6,
}: TooltipProps) => (
  <RadixTooltip.Provider delayDuration={delayDuration} skipDelayDuration={150}>
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          align={align}
          sideOffset={sideOffset}
          className="z-50 select-none rounded-md bg-stone-900/95 px-2.5 py-1.5 text-xs font-sans text-cream-50 shadow-md ring-1 ring-black/[0.06] [will-change:transform,opacity]"
          style={{ color: '#FAF9F6' }}
        >
          {label}
          <RadixTooltip.Arrow className="fill-stone-900/95" width={10} height={5} />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  </RadixTooltip.Provider>
);
